import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { loadTranslation, loadLangList, fetchSystemDowntimeNotification, setSystemDowntimeNotificationSeen } from '../../application_actions';

import DropdownMenu from './dropdown_menu.jsx'
import Notification from './notification.jsx'

//Shows page title on top of the view.
class MenuBar extends Component{
  constructor(props){
    super(props);
  }

  componentDidMount() {
    this.props.loadLangList();
  }

  componentDidUpdate(prevProps){
    // Wait until user has role
    if(this.props.auth.roleAllowed && prevProps.auth.roleAllowed !== this.props.auth.roleAllowed
      || (this.props.auth.roleAllowed && this.props.i18n.language !== prevProps.i18n.language)){
      this.props.fetchSystemDowntimeNotification(this.props.i18n.language);
    }
  }

  onHomeClick(){
    this.context.router.push('/main');
  }

  loadTranslationAndSaveLangCookie (lang) {
    this.props.loadTranslation(lang)
    window.localStorage.setItem('cookie', 'lang=' + lang + ';')
  }

  render(){

    return(
      <>
      {this.props.app?.systemDowntime && this.props.app.systemDowntime.map((notification,key) =>
        <Notification
          key={key}
          downTimeNotification={notification}
          setSystemDowntimeNotificationSeen={this.props.setSystemDowntimeNotificationSeen}
          strings={this.props.i18n.strings}/>
         
      )}
      <div className="menu-bar">
        <div className="menu-left">&nbsp;</div>
        <span className="menu-center" id="menuTitle">
          { this.props.title }
        </span>
        <div className="menu-right">
          <DropdownMenu
            title={this.props.i18n.strings.Login.chooseLanguage}
            options={this.props.i18n.availableLanguages}
            currentSelection={this.props.i18n.language}
            onSelectionChange={(lang) => this.loadTranslationAndSaveLangCookie(lang)}
            isLanguageSelection={true}
          />
        </div>
      </div>
      </>
    );
  }
}

function mapStateToProps( state ) {
  let menuName = state.progress.activePage && state.i18n.strings[state.progress.activePage] ?
    state.i18n.strings[state.progress.activePage].title : undefined;

  return {
    title: menuName,
    i18n: state.i18n,
    app: state.app,
    auth: state.auth
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ loadTranslation, loadLangList, fetchSystemDowntimeNotification, setSystemDowntimeNotificationSeen }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar);
